import { defineStore } from 'pinia'
import axios from 'axios'

const API_BASE = (process.env.VUE_APP_API_URL || 'http://localhost:3333').replace(/\/$/, '')

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('authToken') || '',
    user: JSON.parse(localStorage.getItem('authUser') || 'null'),
    loading: false
  }),
  actions: {
    async login(email, password) {
      this.loading = true
      try {
        const { data } = await axios.post(`${API_BASE}/login`, {
          email,
          password
        })

        this.token = data.token
        this.user = data.user

        localStorage.setItem('authToken', data.token)
        localStorage.setItem('authUser', JSON.stringify(data.user))

        return data
      } finally {
        this.loading = false
      }
    },
    logout() {
      this.token = ''
      this.user = null
      localStorage.removeItem('authToken')
      localStorage.removeItem('authUser')
    },
    isAuthenticated() {
      return !!this.token
    }
  }
})
